import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { CustomAlert, CustomButton, Text } from '../../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../../shared/Helpers/functions';
import { ChevronRightIcon } from '../../../../../../shared/Assets/svg';
import { ButtonWrapper } from '../../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import { getTargets, openTarget } from '../../../../../../redux/State/clientSlice/programTargetSlice';
import { TargetProperties } from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';

const OpenTarget = ({ target }: { target: TargetProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [openSure, setOpenSure] = useState<boolean>(false);
	const { id, programId } = target;
	const includeMastered = useSelector((state) => state.programTarget.includeMastered);

	const loading = useSelector((state) => state.programTarget.loading);

	const openTargetHandler = () => {
		if (!id || !programId) return;

		dispatch(openTarget({ id, programId }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getTargets({ programId, includeMastered }));
				setOpenSure(false);
				toast('Opened');
			})
			.catch(errorNormalizer);
	};

	return (
		<div>
			<div className="actionRow" onClick={() => setOpenSure(true)}>
				<div className="actionIcon">
					<ChevronRightIcon />
				</div>
				<div className="actionContent">
					<Text title="Open Target" type="psm" fontWeight="medium" />
				</div>
			</div>

			<CustomAlert
				open={openSure}
				onClose={() => setOpenSure(false)}
				title="Are you sure?"
				Content={() => (
					<ButtonWrapper>
						<CustomButton title="Open" onClick={openTargetHandler} loading={loading} />
						<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpenSure(false)} />
					</ButtonWrapper>
				)}
			/>
		</div>
	);
};

export default OpenTarget;
